export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            精选专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">编辑精心策划的影视专题内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="sm:col-span-2 lg:col-span-3">
            <div className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-2/5 h-52 lg:h-auto overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Grand%20cinematic%20hero%20visual%20with%20warm%20coral%20and%20amber%20dramatic%20lighting%2C%20epic%20scale%2C%20movie%20marathon%20atmosphere%2C%20premium%20entertainment%20vibe%2C%20no%20text%20or%20brands&width=1000&height=600&seq=carousel-nc-01&orientation=landscape"
                    alt="五一观影指南专题"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="lg:w-3/5 p-6 md:p-8 flex flex-col justify-center">
                  <span className="px-2 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-label self-start">编辑精选</span>
                  <h3 className="mt-3 font-heading font-bold text-lg md:text-xl text-foreground-800 group-hover:text-primary-700 transition-colors">
                    假期观影指南 · 20部必看好片
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 font-label leading-relaxed line-clamp-3">
                    精心挑选假期最值得看的电影片单，涵盖动作、喜剧、悬疑、剧情等多个类型，让你假期不剧荒。97视频和丝瓜视频高清资源已全部上线，打开嫩草视频即可畅看。
                  </p>
                  <div className="mt-4 flex items-center text-primary-600 font-label font-medium text-sm">
                    <span>立即浏览</span>
                    <i className="ri-arrow-right-line ml-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Top%20rated%20Korean%20drama%20visual%20collage%20with%20warm%20amber%20lighting%2C%20romantic%20atmosphere%2C%20soft%20coral%20tone%2C%20entertainment%20aesthetic%2C%20no%20text&width=800&height=450&seq=carousel-nc-02&orientation=landscape"
                alt="韩剧追剧日历专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label">热门专题</span>
              <h3 className="mt-2 font-heading font-bold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                韩剧追剧日历 · 7月更新一览
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label leading-relaxed line-clamp-2">
                最新韩剧上档时间表，再也不怕错过更新
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Classic%20movies%20retro%20visual%20collage%20with%20warm%20vintage%20amber%20lighting%2C%20nostalgic%20atmosphere%2C%20golden%20age%20cinema%20aesthetic%2C%20soft%20film%20grain%2C%20no%20text&width=800&height=450&seq=carousel-nc-03&orientation=landscape"
                alt="经典重温专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label">经典重温</span>
              <h3 className="mt-2 font-heading font-bold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                致敬经典 · 那些年我们追过的电影
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label leading-relaxed line-clamp-2">
                重温60部华语经典影片，满满的青春回忆
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Animation%20and%20anime%20colorful%20collage%20visual%20with%20warm%20coral%20and%20amber%20gradients%2C%20vibrant%20fantasy%20atmosphere%2C%20creative%20energy%2C%20animation%20aesthetic%2C%20no%20text%20or%20characters&width=800&height=450&seq=carousel-nc-04&orientation=landscape"
                alt="动画电影专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-label">动画专场</span>
              <h3 className="mt-2 font-heading font-bold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                动画电影大赏 · 全家一起看
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label leading-relaxed line-clamp-2">
                精选国内外高分动画电影，大人小孩都爱看
              </p>
            </div>
          </div>

          <div className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Variety%20show%20entertainment%20visual%20collage%20with%20bright%20warm%20golden%20lighting%2C%20energetic%20atmosphere%2C%20studio%20stage%20aesthetic%2C%20colorful%20vibrant%20mood%2C%20no%20text&width=800&height=450&seq=carousel-nc-05&orientation=landscape"
                alt="综艺推荐专题"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 md:p-5">
              <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-label">综艺精选</span>
              <h3 className="mt-2 font-heading font-bold text-base text-foreground-800 group-hover:text-primary-700 transition-colors">
                下饭综艺合集 · 边吃边看乐不停
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label leading-relaxed line-clamp-2">
                热门综艺一网打尽，搞笑、竞技、真人秀全收录
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}